import { setReloadMainTable, setReloadMinorTable, setReloadNestedTable, setReloadSubTable } from "../store/slices/auth/authSlice"

export const Callers = (dispatch) => {
    dispatch(setReloadMainTable())
    dispatch(setReloadSubTable())
    dispatch(setReloadMinorTable())
    dispatch(setReloadNestedTable())
}